import {
  Action,
  IntegrationState,
  IntegrationType,
  Resource,
  useGetIntegrationsQuery
} from '@oysterjs/ais/api/graphql';
import { useOptionalCurrentAgencyUser } from '@oysterjs/ais/components/current-user';
import { FEATURE_FLAGS, useFlag } from '@oysterjs/ais/components/feature-flags';

/**
 * Reconciliation writes only to Applied Epic. The flag rolls the feature out,
 * and the access profile's "Reconcile with the AMS" capability is what grants
 * read on it. An agency without an active Epic integration has nothing to
 * write to. Call this once above the thread and pass the result down: a query
 * inside each message would resolve after paint and shift the action bar.
 */
export const useAmsReconciliationEnabled = () => {
  const agencyUser = useOptionalCurrentAgencyUser();
  const flagEnabled = useFlag(FEATURE_FLAGS.AMS_RECONCILIATION);
  const permitted =
    agencyUser?.permissions.some(
      (permission) =>
        permission.resource === Resource.AmsReconciliation && permission.action === Action.Read
    ) ?? false;
  const { data } = useGetIntegrationsQuery({
    fetchPolicy: 'cache-first',
    skip: !flagEnabled || !permitted
  });
  return (
    flagEnabled &&
    permitted &&
    (data?.integrations.some(
      (integration) =>
        integration.type === IntegrationType.AmsAppliedEpic &&
        integration.state === IntegrationState.Active
    ) ??
      false)
  );
};
